

























import GrpTagChoice from "@/interfaces/GrpTagChoice";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BuyersPanel extends Vue {
  tag = "";
  @Prop({ default: false }) readonly guestSelected!: boolean;

  init(choice: GrpTagChoice | null) {
    this.tag = choice?.tag as string;
    this.notify();
  }

  onBuyers() {
    this.tag = "buyers";
    this.notify();
  }
  onNoBuyers() {
    this.tag = "no_buyers";
    this.notify();
  }

  private notify() {
    const choice: GrpTagChoice = {
      tag: this.tag,
      isValid: this.guestSelected || this.tag !== "",
      type: "scalar",
    };
    this.$emit("choice", choice);
  }
}
